import React, { useEffect, useState } from "react"

import useUserFromToken from "../../../hooks/useUserFromToken"
import CompanyRequestModal from "../../users/components/CompanyRequestModal"
import RegistrationFinishedModal from "./RegistrationFinishedModal"

const FinishRegistration = () => {
  const {
    isRecycler,
    isAuditor,
    registrationFinished,
    isRecyclerAndConverter,
    isConverter,
    isSorter,
    isSorterAndRecycler,
  } = useUserFromToken()

  const [companyRequestModalVisible, setCompanyRequestModalVisible] =
    useState(false)

  useEffect(() => {
    if (isAuditor) {
      setCompanyRequestModalVisible(true)
    }
  }, [isAuditor])

  if (!registrationFinished) {
    if (isAuditor) {
      if (!registrationFinished && companyRequestModalVisible) {
        return (
          <CompanyRequestModal
            closeModal={() => setCompanyRequestModalVisible(false)}
          />
        )
      }
    }
  }

  if (isRecycler || isRecyclerAndConverter || isConverter || isSorter || isSorterAndRecycler) {
    return <RegistrationFinishedModal />
  }

  return null
}

export default FinishRegistration
